var Timeline = function () {
  this.fragments = [];
  this.status = 1; // 1 未开始 2 运行中 3 暂停 4 结束
  this.lastTime = null;
  this.stepCallbacks = [];
}

Timeline.prototype = {
  add: function (fragment) {
    this.fragments.push(fragment);
  },
  remove: function (fragment) {
    var index = this.fragments.indexOf(fragment);
    if (index >= 0) {
      this.fragments.splice(index, 1)
    }
  },
  clear: function () {
    this.fragments = [];
  },
  __step: function () {
    if (this.status > 1 && this.status < 4) {
      // console.log('----------');
      var now = new Date().valueOf();
      var spendTime = now - this.lastTime;
      this.lastTime = now;
      if (this.status == 2) {
        for (var i = 0 , iLen = this.stepCallbacks.length; i < iLen; i++) {
          this.stepCallbacks[i](this.fragments, spendTime);
        }
      }
      requestAnimationFrame(this.__step.bind(this));
    }
  },
  start: function () {
    this.status = 2;
    this.lastTime = new Date().valueOf();
    requestAnimationFrame(this.__step.bind(this))
  },
  pause: function () {
    if(this.status == 2) {
      this.status = 3;
    }
  },
  play: function () {
    if (this.status == 3) {
      this.status = 2;
    }
  },
  end: function () {
    this.status = 4;
    this.clear();
  },
  addStepCallBack: function (callback) {
    this.stepCallbacks.push(callback)
  }
};

module.exports = Timeline;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/canvas/timeline.js